import Ecosystem from './Ecosystem'

export default Ecosystem
